import {pref} from "@/assets/plugins/mps-common/preferences/preferences";

export default {

    install(Vue, options) {
        Vue.prototype.$pref = pref;
    }

}